export const checkoutPaymentConfig = {
  checkoutBillingAddress: {
    header: 'Billing address',
    sameBillingAddressCheckbox: 'My billing address is the same as my delivery address',
  },
}
